import { PdProductItem } from '../../interfaces/line-item';

export const fromPdServerFormat = (product: any): Array<PdProductItem> => product;
